import { CoverageType } from '@policyfly/protobuf'
import { jwtDecode } from 'jwt-decode'

import type { JwtPayload } from 'jwt-decode'

/**
 * Returns `true` if a JWT is valid.
 *
 * Returns `false` if the provided JWT is badly formatted
 * or the `exp` timestamp is in the past (with a small buffer).
 */
export function isJWTValid (jwt: string | null): jwt is string {
  if (!jwt) return false
  try {
    const decoded = jwtDecode<JwtPayload>(jwt)
    if (!decoded.exp) return false
    return Date.now() < ((decoded.exp * 1000) - 10000)
  } catch {
    return false
  }
}

/**
 * Converts a coverage data path to an apiPath string for use in api requests.
 *
 * @example
 * For a coverage with data path `coverages.(type=1003).coverages.(type=1001).enabled`,
 * the returned apiPath will be `APD_COVERAGE.TRIA_COVERAGE`.
 */
export function pathToApiPath (path: string): string {
  const match = Array.from(path.matchAll(/coverages\.\(type=(?<value>[^)]+)\)/g), (m) => m.groups?.value)
  return match.reduce<string>((acc, value) => {
    const enumString = CoverageType[Number(value)]
    if (enumString && acc) acc += '.'
    return acc + (enumString ?? '')
  }, '')
}
